import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { IconButton } from "@mui/material";
import { Icon } from "../Icon/Icon";
import { colors } from "../../styles/colors";
import { CustomMenuEnchorNotification } from "./CustomMenuEnchorNotification/CustomMenuEnchorNotification";
import { useReadNotification } from "../../api/notification";
import { getCurrentFleetId } from "../../utils/getCurrentFleet";

type Props = {
  notification: TNotification;
  isRead?: boolean;
};

export const CustomEnchorNotification: FC<Props> = ({
  isRead,
  notification,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { mutate: readNotification } = useReadNotification(getCurrentFleetId());

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onMarkAsRead = () => {
    readNotification(notification.id);
  };

  const onViewEvent = () => {
    // Mark as read silently, then navigate to the event detail page
    if (!isRead) {
      readNotification(notification.id);
    }

    // Parse the notification data to get event_id and vehicle_id
    let data: Record<string, any> = {};
    try {
      data = typeof notification.data === "string"
        ? JSON.parse(notification.data)
        : notification.data || {};
    } catch {
      data = {};
    }

    const eventId = data.event_id;
    const vehicleId = notification.vehicle_id;

    if (eventId && vehicleId) {
      navigate(`/vehicule/update/${vehicleId}/event/${eventId}`);
    } else if (vehicleId) {
      navigate(`/vehicule/update/${vehicleId}`);
    }
  };

  return (
    <div className={classes.menuEnchor}>
      {!isRead && (
        <IconButton aria-label={t("a11y.markAsRead", "Mark as read")} onClick={onMarkAsRead}>
          <Icon
            name="mail"
            width={"24px"}
            height={"24px"}
            color={colors.BLACK}
          />
        </IconButton>
      )}
      <IconButton aria-label={t("a11y.viewEvent", "View event")} onClick={onViewEvent}>
        <Icon name="eye" width={"24px"} height={"24px"} color={colors.BLACK} />
      </IconButton>
      <div>
        <IconButton aria-label={t("a11y.moreOptions", "More options")} onClick={handleClick}>
          <Icon
            name="dots"
            width={"24px"}
            height={"24px"}
            color={colors.BLACK}
          />
        </IconButton>
        <CustomMenuEnchorNotification
          anchorEl={anchorEl}
          open={open}
          handleClose={handleClose}
          notification={notification}
        />
      </div>
    </div>
  );
};
